<template>
	<v-container fluid>
		<v-dialog persistent max-width="1000" v-model="reportModal.show">
			<v-card>
				<v-card-title>
					<div v-if="reportModal.report !== null" v-html="reportModal.report.title"></div>
				</v-card-title>
				<v-card-text class="grey--text text--darken-2">
					<Report :report="reportModal.report"></Report>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="reportModal.show = false" depressed color="error">{{ $t('buttons.close') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-row class="pa-3" v-if="$myStore.state.user.user_role_id == 1">
			<v-btn @click="scanClick" class="ml-0" color="primary">
				<v-icon small>fa-cloud-upload-alt</v-icon>&nbsp;&nbsp;{{ $t('buttons.scan') }}
			</v-btn>

		</v-row>
		<v-row>
			<v-col lg="6" md="8" cols="12">
				<v-card outlined flat>
					<v-card-text>
						<Dropdown
							v-model="buildingId"
							:ajax="true" :data="'buildings'"
							:label="$t('fields.building')"></Dropdown>
						<FullCalendar :options="calendarOptions" v-if="showCalendar && buildingId !== null"/>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import hrLocale from '@fullcalendar/core/locales/hr';
import Report from './Report'
import Dropdown from './trinkets/Dropdown'

export default {
	name: "Dashboard",
	components: {FullCalendar, Report, Dropdown},
	data() {
		return {
			calendarOptions: {
				plugins: [dayGridPlugin, interactionPlugin],
				initialView: 'dayGridMonth',
				locale: hrLocale,
				eventClick: this.reportClick,
				events: [],
				height: 'auto'
			},
			reportModal: {
				show: false,
				report: null
			},
			showCalendar: false,
			buildingId: this.$myStore.state.user.default_building_id
		}
	},
	watch: {
		buildingId: function () {
			this.loadReports();
		}
	},
	computed: {},
	methods: {
		scanClick() {
			let vm = this;
			this.$APICall('post', 'reports/scan', {}, (data, success) => {
				if (success) {
					vm.$alert(vm.$t('alerts.scanDone'));
					vm.loadReports();
				}
			});
		},
		reportClick(event) {
			let report = event.event.extendedProps.report;
			this.reportModal.report = report;
			this.$nextTick(() => {
				this.reportModal.show = true;
			});
		},
		loadReports() {
			this.showCalendar = false;
			let vm = this;
			this.$APICall('get', 'reports', {building_id: this.buildingId}, (data, success) => {
				if (success) {
					vm.calendarOptions.events = data;
					vm.$nextTick(() => {
						vm.showCalendar = true;
					});
				}
			});
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/dashboard', disabled: true}
		]);
		this.loadReports();
	}
}
</script>

<style scoped>
@media (min-width: 500px) {
	>>> .fc-event-title {
		white-space: normal;
	}
}

>>> .fc-daygrid-day-number {
	cursor: default;
}

>>> .fc-col-header-cell-cushion  {
	cursor: default;
}
</style>
